module.exports = __webpack_public_path__ + "img/logo.25ed7f74.png";